
import { Vue, Component, Prop } from "vue-property-decorator";
import { Contractor } from "@/generated/graphql";
import NewTabLink from "@/components/common/NewTabLink.vue";
import CardPagination from "@/components/card/CardPagination.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import ContractorChips from "@/components/companyProjects/ContractorChips.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import ProjectContractorsCardItem from "@/components/projects/ProjectContractorsCardItem.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import ManagementAddContractorInfo from "@/components/contractors/ManagementAddContractorInfoAdditional.vue";
import UIButton from "@/components/button/ui-button.vue";
import NewTabLinkFull from "@/components/common/NewTabLinkFull.vue";
import MailTo from "@/components/common/MailTo.vue";
import PhoneTo from "@/components/common/PhoneTo.vue";
import UiButton from "@/components/button/ui-button-message.vue";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
import { User, User_Profile_By_Management } from "@/generated/graphql";
import ItemChipsData from "@/entities/ItemChipsData";
import GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL from "@/apollo/profile/profileDetails/management/GetProfileDetailByManagementAll.gql";
import CardsContainer from "@/components/card/cardsContainerDeatils.vue";
import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";
import GET_CONTRACTOR_DETAILS from "@/apollo/contractors/GetContractorDetails.gql";
import GET_RESOURCE_INFO from "@/apollo/contractors/GetResourceInfo.gql";
import UserProfileIcon from "@/components/icons/UserProfileIcon.vue";
import { isEmpty } from 'lodash'; 
import ManagementIcon from "@/components/icons/ManagementIcon.vue";

interface ContractorDetails {
  contractor: Contractor;
  activeProjectsCount: number;
  completedProjectsCount: number;
}

interface ManagementAddedInfoMode {
  phone: boolean;
  email: boolean;
  website: boolean;
  country: boolean;
  region: boolean;
  city: boolean;
}

@Component({
  components: {
    EmptyListImageProjects,
    UIButton,
    UiButton,
    MailTo,
    PhoneTo,
    UserProfileIcon,
    ManagementIcon,
    CardPagination,
    NewTabLinkFull,
    EmptyListPlaceholder,
    LoadingOverlay,
    NewTabLink,
    ContractorChips,
    CardBodyItem,
    UiButtonMessage,
    CardsContainer,
    ElementsSizeProvider,
    ManagementAddContractorInfo,
    ProjectContractorsCardItem,
  },
  apollo: {
    contractorDetails: {
      query: GET_CONTRACTOR_DETAILS,
      variables() {
        return this.queryArgs;
      },
      update(data) {
        this.contractorDetails = data;
        return {
          contractor: data.contractor_by_pk,
          activeProjectsCount: data.active.aggregate.count,
          completedProjectsCount: data.completed.aggregate.count,
        };
      },
    },
    // resourceInfo: {
    //   query: GET_RESOURCE_INFO,
    //   variables() {
    //     return this.contractorId_;
    //   },
    //   update(setter) {
    //     return setter.resource_information_card;
    //   },
    // },
    profilesByManagement: {
      query: GET_PROFILE_DETAILS_BY_MANAGEMENT_ALL,
      variables() {
        return {
          userId: this.contractorUserId,
        };
      },
      update(data) {
        return data.user_profile_by_management;
      },
    },
  },
})
export default class ContractorAdditionalInfo extends Vue {
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  modalOpened: boolean = false;
  contractorDetails?: ContractorDetails | null = null;
  profilesByManagement: User_Profile_By_Management[] = [];
  showManagementAddContractorInfoModal: boolean = false;
  location: any[] = [];
  emails: any[] = [];
  managementAddedInfoMode: ManagementAddedInfoMode = {
    email: false,
    phone: false,
    website: false,
    country: false,
    region: false,
    city: false,
  };
  managementAddedInfoModeInit: ManagementAddedInfoMode = {
    email: false,
    phone: false,
    website: false,
    country: false,
    region: false,
    city: false,
  };

  get contractorId_(): Object {
    return {
      contractor_id: this.contractorId,
    };
  }

  get websitesByResource() {
    if (this.contractorDetails) {
      return this.contractorDetails.contractor.user.profile.website;
    }
  }
  get phoneByResource() {
    if (this.contractorDetails) {
      return this.contractorDetails.contractor.user.private_data.phone;
    }
  }

  get isInformation(): boolean {
    return Boolean(this.contractorDetails && this.profilesByManagement);
  }

  get isLoading(): boolean {
    return (
      this.$apollo.queries.profilesByManagement.loading ||
      this.$apollo.queries.contractorDetails.loading
    );
  }

get locationByResource(): string {
  if (this.contractorDetails) {
    const profile = this.contractorDetails.contractor.user.profile;

    let location = "";
    if (!isEmpty(profile?.address)) {
      location += profile.address;
    }
    if (!isEmpty(profile?.city)) {
      location += profile.city;
    }

    if (!isEmpty(profile?.state)) {
      location += (location ? ", " : "") + profile.state;
    }

    if (!isEmpty(profile?.postal_code)) {
      location += (location ? ", " : "") + profile.postal_code;
    }

    if (!isEmpty(profile?.country)) {
      location += (location ? ", " : "") + profile.country;
    }

    return location;
  }

  return "";
}

  get emailByManagement(): ItemChipsData[] {
    if (!this.profilesByManagement.length) {
      return [];
    }
    var emails = [];
    this.profilesByManagement.forEach((profile) => {
      if (profile.email !== '') {
        emails.push({ id: this.contractorId, name: profile.email });
      }
    });
    return emails;
  }

  get phoneByManagement(): ItemChipsData[] {
    if (!this.profilesByManagement.length) {
      return [];
    }
    var phones = [];
    this.profilesByManagement.forEach((profile) => {
      if (profile.phone) {
        phones.push({ id: this.contractorId, name: profile.phone });
      }
    });
    return phones;
  }

  get emailsByResource() {
    if (this.contractorDetails) {
      return this.contractorDetails.contractor.user.private_data.email;
    }
  }

  get websitesByManagement(): ItemChipsData[] {
    if (!this.profilesByManagement.length) {
      return [];
    }
    var websites = [];
    this.profilesByManagement.forEach((profile) => {
      if (profile.website) {
        websites.push({ id: this.contractorId, name: profile.website });
      }
    });
    return websites;
  }

get locationByManagement(): ItemChipsData[] {
  if (!this.profilesByManagement.length) {
    return [];
  }

  const location = [];
  this.profilesByManagement.forEach((profile) => {
    const { city, state, country, postal_code } = profile;
     const allValuesNull = isEmpty(city) && isEmpty(state) && isEmpty(country) && isEmpty(postal_code);
    if (!allValuesNull) {
      const locationObject = {
        id: this.contractorId,
        city: city?.trim() !== "" ? city : null,
        state: state?.trim() !== "" ? state : null,
        country: country?.trim() !== "" ? country : null,
        postal_code: postal_code?.trim() !== "" ? postal_code : null,
        address: profile.address?.trim() !== "" ? profile.address : null,
      };
      const allValuesEmpty = Object.values(locationObject).every(value => isEmpty(value));
      if (!allValuesEmpty) {
        location.push(locationObject);
      } else {
        location.push(null);
      }
    }
  });

  return location.length ? location : [];
}



  get getLocationLength() {
    let length = 0;
    if (this.locationByResource) {
      length += 1;
    }
    if (this.locationByManagement) {
      length += this.locationByManagement.length;
    }
    return length > 0 ? `(${length})` : "";
  }

  get getphoneLength() {
    let length = 0;
    if (this.phoneByResource) {
      length += 1;
    }
    if (this.phoneByManagement) {
      length += this.phoneByManagement.length;
    }
    return length > 0 ? `(${length})` : "";
  }

  get getWebsiteLength() {
    let length = 0;
    if (this.websitesByResource) {
      length += 1;
    }
    if (this.websitesByManagement) {
      length += this.websitesByManagement.length;
    }
    return length > 0 ? `(${length})` : "";
  }

  get getEmailsLength() {
    let length = 0;
    if (this.emailsByResource) {
      length += 1;
    }
    if (this.emailByManagement) {
      length += this.emailByManagement.length;
    }
    return length > 0 ? `(${length})` : "";
  }

  get queryArgs(): Object {
    return {
      id: this.contractorId,
      activeWhere: {
        project_activities: {
          contractor: {
            user_id: {
              _eq: this.contractorUserId,
            },
          },
        },
      },
      completedWhere: {
        project_activities: {
          _and: [
            {
              completed: { _eq: true },
            },
            {
              contractor: {
                user_id: { _eq: this.contractorUserId },
              },
            },
          ],
        },
      },
    };
  }

  refetchCollection(): void {
    this.$apollo.queries.projects.refetch();
  }
}
